import React from 'react';
export const LocaleContext = React.createContext('en');
export const InternalCalendarDateContext = React.createContext({
    date: new Date(),
    setDate: () => undefined
});
export const UserSelectedDateContext = React.createContext({
    date: new Date(),
    setDate: () => undefined
});
